/*global _moovilaSecurity */
/*eslint no-undef: "error"*/
import React, { Component } from 'react';
import $                    from 'webpack-zepto';
import Editor               from 'react-ace';
import { Link }             from 'react-router-dom';

import 'brace/ext/language_tools';
import 'brace/mode/javascript';
import 'brace/theme/tomorrow';
import 'brace/ext/searchbox';

import { CustomDialog, QuestionBox } from 'moovila-common';

import formatBytes from '../../utilities/formatBytes';

class APIConsoleModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      params: '',
      confirm10x: false,
      businessRules: [],
      security: [],
      parameters: [],
      content: [],
    }
    this.handle10xClick = this.handle10xClick.bind(this);
    this.onLoad         = this.onLoad.bind(this);
    this.onChange       = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { subject, request, method } = nextProps;
    if (!subject || !request) {
      return; // maybe redirect?
    }
    if (
      !this.state.params.length ||
      this.props.method !== method ||
      this.props.subject !== subject ||
      this.props.request !== request
    ) {
      if (!this.props.api.subjects.filter(sub => sub.Subject === this.props.subject)[0]) {
        this.setState({params: ''});
        setTimeout(() => this.componentWillReceiveProps(...arguments), 100);
        return;
      }
      const endpoint = this.props.api.subjects.filter(sub => sub.Subject === this.props.subject)[0].APICalls.filter(call => call.Request === this.props.request)[0];
      const params = endpoint.Parms;
      const p = params ? JSON.stringify(params, null, '  ') : '';
      this.setState({
        params: p,
      });
      if (endpoint && endpoint.Validation) {
        this.setState({
          businessRules: endpoint.Validation.BusinessRules || [],
          security: endpoint.Validation.Security || [],
          parameters: endpoint.Validation.Parameters || [],
          content: endpoint.Validation.Content || [],
        });
      } else {
        this.setState({
          businessRules: [],
          security: [],
          parameters: [],
          content: [],
        });
      }
    }
  }

  handle10xClick() {
    this.setState({
      confirm10x: true,
    });
    // this.props.executeAPITest10x(this.state.params);
  }

  onLoad() {
    // idk
  }

  onChange(val) {
    this.setState({
      params: val,
    });
  }

  render() {
    const {
      method,
      subject,
      request,
      response,
      results,
      canRepeat10x,
      timer,
      executeAPITest,
    } = this.props;

    if (method !== 'request') {
      $('body, html').removeClass('lock-scroll');
      return null;
    }

    $('body, html').addClass('lock-scroll');

    let modal = null;
    if (this.state.confirm10x) {
      modal = (
        <QuestionBox
          title='Execute Request 10 Times?'
          yesCallback={() => {
            this.props.executeAPITest10x(this.state.params);
            this.setState({confirm10x: false})
          }}
          noCallback={() => this.setState({confirm10x: false})}
        >
          Are you sure you want to execute this request 10 times?
        </QuestionBox>
      );
    }

    // QuestionBox = ({ children, title, yesTo=false, yesText, noTo=false, noText, yesCallback, noCallback, size='md', disabled }) => {

    let duration = `${timer} ms`;
    if (timer === 0) {
      duration = 'In Progress...'
    }
    if (timer === null) {
      duration = '';
    }

    // make the button row
    const buttons = (
      <section className='section'>
        <div className='row'>
          <div className='col-xs-3 half-gutter-r'>
            <button className='btn btn-default btn-block btn-md' onClick={e => executeAPITest(this.state.params)}>
              Execute Request
            </button>
          </div>
          <div className='col-xs-3 half-gutter-r'>
            <button className='btn btn-default btn-block btn-md' onClick={e => executeAPITest(this.state.params, true)}>
              If Needed
            </button>
          </div>
          <div className='col-xs-3'>
            <button className='btn btn-default btn-block btn-md' onClick={canRepeat10x ? this.handle10xClick : () => {}} disabled={!canRepeat10x}>
              Execute 10x
            </button>
          </div>
          <div className='col-xs-3 half-gutter-l'>
            <Link className='btn btn-default btn-block btn-md' style={{color: '#fff'}} to='/utilities/api-console'>Cancel</Link>
          </div>
        </div>
      </section>
    );

    let value;
    if (timer !== 0) {
      if (results) {
        value = results;
      } else {
        value = response;
      }
    }

    const businessRules = this.state.businessRules.map((rule, i) => <li key={i}>{rule}</li>);
    const security = this.state.security.map((rule, i) => <li key={i}>{rule}</li>);
    const parameters = this.state.parameters.map((rule, i) => <li key={i}>{rule}</li>);
    const content = this.state.content.map((rule, i) => <li key={i}>{rule}</li>);
    const requestSize = <span style={{color: '#000'}}>{formatBytes((new TextEncoder('utf-8').encode(this.state.params)).length)}</span>;
    const responseSize = <span style={{color: '#000'}}>{formatBytes((new TextEncoder('utf-8').encode(response)).length)}</span>;
    const isCached = this.props.isCached ? <span style={{marginLeft: 3}} className='label label-success'>Cached</span> : null;

    // return the component
    return (
      <div>
        <CustomDialog
          title='API Request Tester'
          backTo='/utilities/api-console'
          size='lg'
          buttons={buttons}
        >
          <section className='section'>
            <div className='row'>
              <div className='col-xs-6 form-group'>
                <h3 className='body-title'>
                  <span className='text-primary'>Enterprise:</span>
                  <span className='pad-left' id='APIRequest_lblUserGUID'>{_moovilaSecurity.GetEnterpriseGUID()}</span>
                </h3>
                <h3 className='body-title'>
                  <span className='text-primary'>User:</span>
                  <span className='pad-left' id='APIRequest_lblSessionGUID'>{_moovilaSecurity.GetUserGUID()}</span>
                </h3>
                <h3 className='body-title'>
                  <span className='text-primary'>Session:</span>
                  <span className='pad-left' id='APIRequest_lblEnterpriseGUID'>{_moovilaSecurity.GetSessionGUID()}</span>
                </h3>
                <hr />
                <h3 className='body-title'>
                  <span className='text-primary'>Request Parameters:</span>
                </h3>
                <Editor
                  editorProps={{ $blockScrolling: Infinity }}
                  className='APIConsole__editor'
                  mode="javascript"
                  theme="tomorrow"
                  name="jsonEditorRequest"
                  onLoad={this.onLoad}
                  onChange={this.onChange}
                  fontSize={10}
                  width='360px'
                  height='275px'
                  showPrintMargin={true}
                  showGutter={false}
                  highlightActiveLine={false}
                  value={this.state.params}
                  setOptions={{
                    enableBasicAutocompletion: false,
                    enableLiveAutocompletion: false,
                    enableSnippets: false,
                    showLineNumbers: false,
                    tabSize: 2,
                  }}
                />
                <h3 className='body-title'>
                  <span className='text-primary'>Request Size: {requestSize}</span>
                  <span className='pad-left' id='APIRequest_lblRequestSize'></span>
                </h3>
              </div>
              <div className='col-xs-6 form-group'>
                <h3 className='body-title'>
                  <span className='text-primary'>Subject:</span>
                  <span className='pad-left' id='APIRequest_lblSubject'>{subject}</span>
                </h3>
                <h3 className='body-title'>
                  <span className='text-primary'>Request:</span>
                  <span className='pad-left' id='APIRequest_lblRequest'>{request}</span>
                </h3>
                <h3 className='body-title'>
                  <span className='text-primary'>Time:</span>
                  <span className='pad-left' id='APIRequest_lblTime'>{duration}</span>
                </h3>
                <hr />
                <h3 className='body-title'>
                  <span className='text-primary'>Response Data:</span>
                </h3>
                <Editor
                  editorProps={{ $blockScrolling: Infinity }}
                  className='APIConsole__editor'
                  mode="javascript"
                  theme="tomorrow"
                  name="jsonEditorResponse"
                  onLoad={this.onLoad}
                  fontSize={10}
                  width='360px'
                  height='275px'
                  showPrintMargin={true}
                  showGutter={false}
                  highlightActiveLine={false}
                  value={value}
                  setOptions={{
                    enableBasicAutocompletion: false,
                    enableLiveAutocompletion: false,
                    enableSnippets: false,
                    readOnly: true,
                    showLineNumbers: false,
                    tabSize: 2,
                  }}
                />
                <h3 className='body-title'>
                    <span className='text-primary'>Response Size: {responseSize} {isCached}</span>
                    <span className='pad-left' id='APIRequest_lblResponseSize'></span>
                </h3>
              </div>
            </div>
            { this.state.businessRules.length || this.state.security.length || this.state.parameters.length || this.state.content.length ? (
              <div className='row APIConsole__rule-container'>
                { this.state.businessRules.length ?
                  <div className='col-xs-6'>
                    <h3 className='APIConsole__rule-heading'>Business Rules</h3>
                    <ul className='APIConsole__rules'>
                      { businessRules }
                    </ul>
                  </div>
                  : null
                }
                { this.state.security.length ?
                  <div className='col-xs-6'>
                    <h3 className='APIConsole__rule-heading'>Security</h3>
                    <ul className='APIConsole__rules'>
                      { security }
                    </ul>
                  </div>
                  : null
                }
                { this.state.parameters.length ?
                  <div className='col-xs-6'>
                    <h3 className='APIConsole__rule-heading'>Parameters</h3>
                    <ul className='APIConsole__rules'>
                      { parameters }
                    </ul>
                  </div>
                  : null
                }
                { this.state.content.length ?
                  <div className='col-xs-6'>
                    <h3 className='APIConsole__rule-heading'>Content</h3>
                    <ul className='APIConsole__rules'>
                      { content }
                    </ul>
                  </div>
                  : null
                }
              </div>
            ) : null }
          </section>
        </CustomDialog>
        { modal }
      </div>
    );
  }
}

export default APIConsoleModal;
                


// WEBPACK FOOTER //
// ./src/components/Utilities/APIConsoleModal.js